import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";
import {Inject, Injectable} from "@angular/core";

export class SpecialScheduleDiscontinueAction {
    constructor(public specialScheduleId: number) {
    }
}

/**
 * Action Service to discontinue a special schedule
 */
@Injectable()
export class SpecialScheduleDiscontinueService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "special-schedule-discontinue");
    }
}
